// api should be here
import { http } from '@/utils/http';
import qs from 'qs';

const getBaseInfo = (data: any) => {
  return http.post(`/v1/dscm/review/login`, qs.stringify(data));
};
const save = (data: any) => {
  return http.post(`/v1/dscm/review/submit`, qs.stringify(data));
};

const review = (data: any) => {
  return http.post(`/v1/dscm/review/stat`, qs.stringify(data));
};
const record = (data: any) => {
  return http.get(`/v1/dscm/review/stat`, {
    params: {
      ...data,
    },
  });
};

const getTips = () => {
  return http.get(`/v1/dscm/review/tips/onebyone`);
};

const postTips = (data: any) => {
  return http.post(`/v1/dscm/review/tips`, qs.stringify(data));
};

const update = (data: any) => {
  return http.post(`/v1/dscm/review/update`, qs.stringify(data));
};

const single = (data: any) => {
  return http.get(`/v1/dscm/review/single`, {
    params: {
      ...data,
    },
  });
};
export { getBaseInfo, save, review, record, getTips, postTips, update, single };
